export const handleSystemErrorReport = (
  error: string | Error,
  interaction?: string,
) => {
  const errorMessage =
    error instanceof Error ? error.message : error || 'unknown';

  dataLayer.push({
    event: 'mb_site_error',
    error_type: 'system_error',
    error_message: errorMessage,
    error_interaction: interaction || 'initial',
    error_page: window.location.href,
  });
};
